import { Navigate, Route, Routes } from 'react-router-dom';

import { SearchView } from './search.view';

export const SearchRoutes = (): JSX.Element => {
  return (
    <Routes>
      <Route index element={<Navigate to="conversations" replace />} />
      <Route path=":scope" element={<SearchView />} />

      {/* Redirect legacy search contacts routes to the contacts routes. */}
      <Route path="users" element={<Navigate to="/contacts/user" replace />} />
      <Route
        path="companies"
        element={<Navigate to="/contacts/company" replace />}
      />
    </Routes>
  );
};
